__turbopack_context__.v({
  "benefit": "journeyElite-module-scss-module__98ijnW__benefit",
  "benefit-in": "journeyElite-module-scss-module__98ijnW__benefit-in",
  "benefitIcon": "journeyElite-module-scss-module__98ijnW__benefitIcon",
  "city": "journeyElite-module-scss-module__98ijnW__city",
  "community": "journeyElite-module-scss-module__98ijnW__community",
  "connectionDot": "journeyElite-module-scss-module__98ijnW__connectionDot",
  "eyebrow": "journeyElite-module-scss-module__98ijnW__eyebrow",
  "fallback": "journeyElite-module-scss-module__98ijnW__fallback",
  "globe": "journeyElite-module-scss-module__98ijnW__globe",
  "globeLayer": "journeyElite-module-scss-module__98ijnW__globeLayer",
  "pin": "journeyElite-module-scss-module__98ijnW__pin",
  "pinMark": "journeyElite-module-scss-module__98ijnW__pinMark",
  "progress": "journeyElite-module-scss-module__98ijnW__progress",
});
